/**
 * Returns true when a config node is enabled via isEnable (or legacy boolean).
 */
export const isConfigEnabled = (config, defaultValue = true) => {
    if (config == null) {
        return defaultValue;
    }

    if (typeof config === 'boolean') {
        return config;
    }

    if (typeof config.isEnable === 'boolean') {
        return config.isEnable;
    }

    return defaultValue;
};
